module.exports = __webpack_public_path__ + "img/under-construction.2af7dd02.jpg";